import { COLORS } from '@btime/constants'
import { trim } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { VerticalLine } from '../../../../components/shapes/Line'
import { useLinkTreeFormActions } from '../_form/LinkTreeFormHandler'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import IconPicker from '../../../../components/form/IconPicker'
import Input from '../../../../components/form/Input'

const LinkTreeItemLink = ({ item, isTheOnlyOne, index }) => {
  const { t } = useTranslation('editLinkTreeItems')
  const { handleChange } = useLinkTreeFormActions()

  React.useEffect(() => {
    if (!isTheOnlyOne) handleChange(index, 'isDefault', false)
  }, [isTheOnlyOne, handleChange, index])

  return (
    <FlexGrid direction="row" justify="space-between">
      <FlexCol flex={3}>
        <IconPicker value={item.icon} size="1.5rem" onChange={handleChange(index, 'icon')} hideOn />
      </FlexCol>
      <VerticalLine lineColor={COLORS.light2} fullHeight />
      <FlexCol flex={4}>
        <Input
          value={item.label}
          onStopTyping={handleChange(index, 'label')}
          placeholder={t('titlePlaceholder')}
          bgColor={!item.enabled && COLORS.dark3}
        />
      </FlexCol>
      <VerticalLine lineColor={COLORS.light2} fullHeight />
      <FlexCol flex={4}>
        <Input
          value={item.url}
          onStopTyping={value => handleChange(index, 'url', trim(value))}
          placeholder={t('urlPlaceholder')}
        />
      </FlexCol>
    </FlexGrid>
  )
}

export default LinkTreeItemLink
